<template>
  <div class="wrap">
    <el-carousel trigger="click" @change="changeBanner" :interval="5000" :height="bannerHeight+'px'">

      <el-carousel-item v-for="(item, index) of bannerImgs" :key="index">
        <img ref="bannerHeight" class="banner-img" :src="item.cover">
      </el-carousel-item>

    </el-carousel>


    <div class="content-layout" v-if="!isMobile">
      <div class="news-title">
        <label class="new-msg">最新消息</label>
        <span class="dot"></span>
        <div class="line"></div>
      </div>

      <div class="news-items">


        <div class="item" v-if="newsList[0]">
          <label style="color:#A05200;font-size: 18px;">{{ newsList[0].guide }}</label>
          <label class="item-home-title" @click="choose(newsList[0])">{{ newsList[0].title }}</label>
          <div class="item-content-html" @click="choose(newsList[0])">{{ newsList[0].description }}</div>
          <div class="detail" @click="choose(newsList[0])">詳細內容 <img style="width:6px;height:10px"
              src="../assets/arrow_right.png">
          </div>
        </div>

        <div style="width:100px"></div>

        <div class="item" v-if="newsList[1]">
          <label style="color:#A05200;font-size: 18px;">{{ newsList[1].guide }}</label>
          <label class="item-home-title" @click="choose(newsList[1])">{{ newsList[1].title }}</label>
          <div class="item-content-html" @click="choose(newsList[1])">{{ newsList[1].description }}</div>
          <div class="detail" @click="choose(newsList[1])">詳細內容 <img style="width:6px;height:10px"
              src="../assets/arrow_right.png">
          </div>
        </div>


      </div>


      <!-- 新增图片集和视频库 -->
      <div class="media-items">

        <div class="media-item1">
          <div class="news-title">
            <label class="new-msg">圖片集</label>
            <span class="dot"></span>
            <div class="line"></div>
          </div>

          <div class="media-item1-img-list">
            <div class="media-item1-img-index" @click="choosePhoto(imgDatas[0])">
              <img class="media-item1-img" :src="imgDatas[0].img_url">
              <label class="media-item1-text">{{ imgDatas[0].name }}</label>
              <label style="color:#A05200;margin-top:5px;font-size: 16px;">{{ imgDatas[0].guide }}</label>
            </div>
            <div class="media-item1-img-index" @click="choosePhoto(imgDatas[1])">
              <img class="media-item1-img" :src="imgDatas[1].img_url">
              <label class="media-item1-text">{{ imgDatas[1].name }}</label>
              <label style="color:#A05200;margin-top:5px;font-size: 16px;">{{ imgDatas[1].guide }}</label>
            </div>
            <div class="media-item1-img-index" @click="choosePhoto(imgDatas[2])">
              <img class="media-item1-img" :src="imgDatas[2].img_url">
              <label class="media-item1-text">{{ imgDatas[2].name }}</label>
              <label style="color:#A05200;margin-top:5px;font-size: 16px;">{{ imgDatas[2].guide }}</label>
            </div>

          </div>
        </div>


        <div style="width:68px"></div>

        <div class="media-item1">
          <div class="news-title">
            <label class="new-msg">精彩視頻</label>
            <span class="dot"></span>
            <div class="line"></div>
          </div>


          <div class="media-item2">
            <img class="media-item2-video" :src="videoData.img_url">
            <img class="start-btn-img" src="../assets/start_video.png" @click="openVideo" />
          </div>



        </div>
      </div>

      <div class="news-title" style="margin-top:88px">
        <label style="font-size:28px;color:#301E03">友情鏈接</label>
        <span class="dot"></span>
        <div class="line"></div>
      </div>

      <div class="friends-link">
        <div v-for="(item, index) in friendsLink" :key="index" class="link-item" @click="toFriendUrl(item.url)">
          {{ item.name }}
        </div>
      </div>

    </div>


    <div class="content-layout-mobile" v-else>

      <div class="news-title-mobile">
        <label class="new-msg-mobile">最新消息</label>
        <span class="dot-mobile"></span>
        <div class="line-mobile"></div>
      </div>

      <div class="news-items-mobile">

        <div class="item-mobile" v-if="newsList[0]">
          <label style="color:#A05200;font-size: 16px;">{{ newsList[0].guide }}</label>
          <label class="item-home-title-mobile" @click="choose(newsList[0])">{{ newsList[0].title }}</label>
          <div v-html="newsList[0].description" class="item-content-html-mobile" @click="choose(newsList[0])"></div>
          <div class="detail-mobile" @click="choose(newsList[0])">詳細內容 <img style="width:6px;height:10px"
              src="../assets/arrow_right.png">
          </div>
        </div>

        <div class="item-mobile" style="margin-top:44px" v-if="newsList[1]">
          <label style="color:#A05200;font-size: 16px;">{{ newsList[1].guide }}</label>
          <label class="item-home-title-mobile" @click="choose(newsList[1])">{{ newsList[1].title }}</label>

          <div v-html="newsList[1].description" class="item-content-html-mobile" @click="choose(newsList[1])"></div>

          <div class="detail-mobile" @click="choose(newsList[1])">詳細內容 <img style="width:6px;height:10px"
              src="../assets/arrow_right.png">
          </div>
        </div>


      </div>




      <!-- 视频库和图片库 手机！ -->
      <div class="media-items-mobile">



        <div class="news-title-mobile">
          <label class="new-msg-mobile">圖片集</label>
          <span class="dot-mobile"></span>
          <div class="line-mobile"></div>
        </div>

        <div class="media-item1-img-list">
          <div class="media-item1-img-index" @click="choosePhoto(imgDatas[0])">
            <img class="media-item1-img" :src="imgDatas[0].img_url">
            <label  class="media-item1-text" >{{ imgDatas[0].name }}</label>
            <label style="color:#A05200;margin-top:5px;font-size: 16px;">{{ imgDatas[0].guide }}</label>
          </div>
          <div class="media-item1-img-index" @click="choosePhoto(imgDatas[1])">
            <img class="media-item1-img"  :src="imgDatas[1].img_url">
            <label class="media-item1-text" >{{ imgDatas[1].name }}</label>
            <label style="color:#A05200;margin-top:5px;font-size: 16px;">{{ imgDatas[1].guide }}</label>
          </div>
        </div>


        <div style="height:60px"></div>

        <div class="news-title-mobile">
          <label class="new-msg-mobile">精彩視頻</label>
          <span class="dot-mobile"></span>
          <div class="line-mobile"></div>
        </div>


        <div class="media-item2">
          <img class="media-item2-video" :src="videoData.img_url">
          <img class="start-btn-img" src="../assets/start_video.png" @click="openVideo" />
        </div>


      </div>

      <div class="news-title-mobile" style="margin-top:60px">
        <label style="font-size:22px;color:#301E03">友情鏈接</label>
        <span class="dot-mobile"></span>
        <div class="line-mobile"></div>
      </div>


      <div class="friends-link-mobile">
        <div v-for="(item, index) in friendsLink" :key="index" class="link-item" @click="toFriendUrl(item.url)">
          {{ item.name }}
        </div>

      </div>


    </div>

    <VideoDialog ref="myVideoDialog"></VideoDialog>

  </div>



</template>

<script>
import VideoDialog from '../components/video_dialog.vue';
export default {
  name: 'Home',
  components: {
    VideoDialog,
  },
  data() {
    return {
      activeIndex: '1',
      bannerImgs: [],
      friendsLink: [],
      newsList: [],
      bannerHeight: "185",
      isMobile: false,
      videoData: {},
      imgDatas: [],
    }
  },

  created() {
    this.isMobile = window.isMobile
  },

  mounted() {

    var that = this;
    this.$axios.get("index/link").then(function (response) {
      that.friendsLink = response.data.data
    });

    this.$axios.get("index/banner").then(function (response) {
      that.bannerImgs = response.data.data
      setTimeout(() => {
        that.getImgHeight();
      }, 300)
    });

    this.$axios.get("article/lists", { params: { cateId: "9" } }).then(function (response) {
      that.newsList = response.data.data
    });


    this.$axios.get("video/index").then(function (response) {
      that.videoData = response.data.data
    });

    this.$axios.get("img/index").then(function (response) {
      that.imgDatas = response.data.data
    });


  },

  methods: {
    //动态调整banner高度
    changeBanner(e) {
      let ref = this.$refs
      this.bannerHeight = ref.bannerHeight && ref.bannerHeight.length ? ref.bannerHeight[e].height : '';
      if (this.bannerHeight <= 0) {
        this.bannerHeight = 185
      }
    },
    imgLoad() {
      try {
        this.$nextTick(() => {
          let ref = this.$refs
          this.bannerHeight = ref.bannerHeight && ref.bannerHeight.length ? ref.bannerHeight[0].height : '';
          console.log(" this.bannerHeight")
          console.log(this.bannerHeight)
          if (this.bannerHeight <= 0) {
            this.bannerHeight = 185
          }
        })
      } catch (err) {
        console.log('errerrerrerrerr ' + err);
      }

    },
    getImgHeight() {

      this.imgLoad();
      window.addEventListener('resize', () => {
        this.imgLoad();
      }, false)

    },
    choose(item) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      this.$router.push({ name: 'detail', params: { type: "news", data: item, } });
    },
    toFriendUrl(url) {
      if (typeof url === 'undefined' || url == null || url === '') {
        return
      }
      window.open(url, "_blank");
    },
    openVideo() {
      this.$refs.myVideoDialog.openVideo(this.videoData.video_url)
    },
    choosePhoto(item) {
      this.$router.push({ name: 'media', params: { imageData: item } });
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }

  },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.wrap {
  width: 100%;
  display: flex;
  background-color: #EFE9E0;
  background-size: cover;
  flex-direction: column;
  align-items: center;


  @media only screen and (max-width: 1200px) {
    ::v-deep .el-carousel {
      width: 100%;

      .el-carousel__indicators {
        width: 100%;
        margin: 0px auto;
        text-align: center;
      }

      .el-carousel__indicator--horizontal {
        margin: 0 5px;
      }

      .el-carousel__button {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #fff;
      }
    }
  }

  @media only screen and (min-width: 1200px) {
    ::v-deep .el-carousel {
      width: 100%;

      .el-carousel__indicators {
        width: 100%;
        margin: 0px auto;
        text-align: center;
      }

      .el-carousel__indicator--horizontal {
        margin: 0 15px;
      }

      .el-carousel__button {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #fff;
      }
    }
  }

  .banner-img {
    width: 100%;
    background-repeat: no-repeat;
    object-fit: fill;
  }

  .content-layout {
    margin-bottom: 44px;
    margin-top: 58px;
    width: 1042px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .news-title {
      height: 40px;
      display: flex;
      align-items: center;

      .new-msg {
        font-size: 28px;
        color: #301E03;
      }

      .dot {
        margin-left: 26px;
        width: 9px;
        height: 9px;
        display: inline-block;
        background: #D9CAB2;
        border-radius: 9px;
      }

      .line {
        flex: 1;
        height: 2px;
        background-color: #D9CAB2;
      }
    }

    .news-items {
      margin-top: 48px;
      display: flex;
      height: 246px;

      .item {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }

      .item-home-title {
        margin-top: 20px;
        color: #301E03;
        font-size: 24px;
        cursor: pointer;
        -webkit-line-clamp: 1;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }

      .item-content-html {
        color: #301E03;
        margin-top: 12px;
        font-size: 16px;
        width: 446px;
        cursor: pointer;
        overflow: hidden;
        height: 87px;
        line-height: 22px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        margin-bottom: 10px;
      }

      .detail {
        cursor: pointer;
        width: 102px;
        height: 30px;
        background-color: #D9C8AD;
        font-size: 16px;
        border-radius: 5px;
        color: #A05200;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
      }
    }


    .media-items {
      margin-top: 48px;
      display: flex;

      .media-item1 {
        width: 518px;
        display: flex;
        flex-direction: column;

        .media-item1-img-list {
          margin-top: 33px;
          display: flex;

          .media-item1-img-index {
            cursor: pointer;
            display: flex;
            flex-direction: column;
            flex: 1;
          }

          .media-item1-img-index:not(:last-child) {
            margin-right: 13px;
          }

          .media-item1-img {
            width: 164px;
            height: 200px;
            background-repeat: no-repeat;
            background-position: center;
            object-fit: cover;
            border-radius: 6px;
          }

          .media-item1-text {
            display: inline-block;
            white-space: nowrap;
            width: 164px;
            overflow: hidden;
            text-overflow: ellipsis;
            color:#301E03;
            margin-top:14px;
            font-size: 16px;
          }
        }


      }

      .media-item2 {
        box-sizing: border-box;
        padding-left: 15px;
        margin-top: 33px;
        width: 448px;
        height: 252px;
        position: relative;


        .media-item2-video {
          border-radius: 6px;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .start-btn-img {
          cursor: pointer;
          border-radius: 50%;
          box-shadow: 0px 0.5px 0.5px 0.5px #EFE9E0;
          position: absolute;
          left: 50%;
          top: 50%;
          width: 42px;
          height: 42px;
          transform: translate(-50%, -50%);

        }

      }
    }

    .friends-link {
      margin-top: 48px;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      flex-wrap: wrap;

      .link-item {
        cursor: pointer;
        text-align: left;
        margin-bottom: 14px;
        width: 20%;
        font-size: 16px;
        color: #301E03;
      }
    }



  }


  .content-layout-mobile {
    padding-bottom: 40px;
    margin-top: 38px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;

    .news-title-mobile {
      box-sizing: border-box;
      padding-left: 28px;
      padding-right: 4px;
      width: 100%;
      height: 32px;
      display: flex;
      align-items: center;

      .new-msg-mobile {
        font-size: 22px;
        color: #301E03;
      }

      .dot-mobile {
        margin-left: 12px;
        width: 6px;
        height: 6px;
        display: inline-block;
        background: #D9CAB2;
        border-radius: 6px;
      }

      .line-mobile {
        flex: 1;
        height: 1.6px;
        background-color: #D9CAB2;
      }
    }



    .news-items-mobile {
      box-sizing: border-box;
      padding-left: 28px;
      padding-right: 28px;
      width: 100%;
      margin-top: 22px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .item-mobile {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }

      .item-home-title-mobile {
        margin-top: 12px;
        color: #301E03;
        font-size: 20px;
        cursor: pointer;
        -webkit-line-clamp: 1;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }

      .item-content-html-mobile {
        margin-top: 12px;
        width: 100%;
        line-height: 150%;
        cursor: pointer;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden
      }

      .detail-mobile {
        margin-top: 18px;
        cursor: pointer;
        width: 84px;
        height: 26px;
        background-color: #D9C8AD;
        font-size: 14px;
        border-radius: 4px;
        color: #A05200;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
      }
    }


    .media-items-mobile {
      box-sizing: border-box;
      width: 100%;
      margin-top: 48px;
      display: flex;
      flex-direction: column;



      .media-item1-img-list {
        padding-left: 28px;
        padding-right: 28px;
        margin-top: 30px;
        display: flex;

        .media-item1-img-index {
          display: flex;
          flex-direction: column;
          flex: 1;
        }

        .media-item1-img {
          width: 152px;
          height: 188px;
          background-repeat: no-repeat;
          background-position: center;
          object-fit: cover;
          border-radius: 6px;
        }

        .media-item1-text {
            display: inline-block;
            white-space: nowrap;
            width: 164px;
            overflow: hidden;
            text-overflow: ellipsis;
            color:#301E03;
            font-size: 16px;
            color:#301E03;
            margin-top:10px;
            font-size: 16px;
          }
      }




      .media-item2 {
        margin-top: 32px;
        padding-left: 28px;
        padding-right: 28px;
        position: relative;

        .media-item2-video {
          width: calc(100vw - 56px);
          height: calc(((100vw - 56px) * 9)/16);
          border-radius: 6px;
          object-fit: cover;
        }


        .start-btn-img {
          cursor: pointer;
          border-radius: 50%;
          box-shadow: 0px 0.5px 0.5px 0.5px #EFE9E0;
          position: absolute;
          left: 50%;
          top: 50%;
          width: 38px;
          height: 38px;
          transform: translate(-50%, -50%);
        }

      }
    }


    .friends-link-mobile {
      box-sizing: border-box;
      padding-left: 28px;
      padding-right: 28px;
      width: 100%;
      margin-top: 32px;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      flex-wrap: wrap;

      .link-item {
        color: #53442E;
        cursor: pointer;
        text-align: left;
        margin-bottom: 20px;
        width: 50%;
        font-size: 14px;
      }
    }

  }


}
</style>

